import * as React from 'react';

import { trackEvent } from '../tracking/trackingEvent';

export interface IAnalyticsParams {
  label: string;
  category: string;
}

export function withAnalytics<T>({ category, label }: IAnalyticsParams, Component: React.ComponentType<T>) {
  const ComponentWithAnalytics: React.FC<T> = (wrappedProps: T) => {
    React.useEffect(() => {
      trackEvent(category, label, 'show');
    }, []);

    return <Component {...wrappedProps} />;
  };

  return ComponentWithAnalytics;
}
